import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";

import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

export const CashOutFooterMessageComponent = observer(
	function CashOutFooterMessageComponent(props: {
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
	}) {
		const { store } = props;

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		const { t } = useTranslation();
		const methods = useForm();

		const { register, handleSubmit, watch } = methods;

		const isAccepted = watch("isChangeAccepted", false);
		const onSubmit = (data: OpenCashoutModalType) => {
			if (cashoutStore.cashoutModalData) {
				store.submitCashout({
					id: cashoutStore.cashoutModalData?.id,
					calculatedCashoutAmount:
						cashoutStore.cashoutModalData?.calculatedCashoutAmount,
					displayedAmount:
						cashoutStore.cashoutModalData.displayedAmount,
					userId: cashoutStore.cashoutModalData.userId,
					cType: cashoutStore.cashoutModalData?.cType,
					isLive: cashoutStore.cashoutModalData?.isLive,
					isChangeAccepted: data.isChangeAccepted || false,
					liveBetSlipCountdown:
						cashoutStore.cashoutModalData?.liveBetSlipCountdown,
				});
			}
		};

		return (
			<>
				<FormProvider {...methods}>
					<form
						onSubmit={handleSubmit(onSubmit)}
						id="cashout-form"
						className="popup__footer__col"
					>
						<InfoMessageComponent
							type="warning"
							size="sml"
							message={cashoutStore.cashoutModalData?.message}
						/>
						<div className="form__group input--check u-mar--reset">
							<input
								id="isChangeAccepted"
								className="input--check__box"
								type="checkbox"
								{...register("isChangeAccepted")}
								name="isChangeAccepted"
							/>
							<label
								className="input--check__label"
								htmlFor="isChangeAccepted"
							>
								{t<string>(
									"mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT"
								)}
							</label>
						</div>

						<div className="popup__footer u-padd--reset">
							<button
								id="close"
								className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
								type="button"
								onClick={store.cancelCashout}
							>
								{t<string>("COMMON.CANCEL")}
							</button>
							<button
								className="popup__btn popup__btn--primary btn btn--med btn--success"
								type="submit"
								disabled={!isAccepted}
							>
								{t<string>("mybets:CASHOUT.TITLE")}{" "}
								{
									cashoutStore.cashoutModalData
										?.calculatedCashoutAmount
								}{" "}
								{store.currentBet && store.currentBet.currency}
							</button>
						</div>
					</form>
				</FormProvider>
			</>
		);
	}
);
